import { createSignal, onCleanup, onMount } from "solid-js";
import {
	DOCUMENT_PREVIEW_EVENT,
	type DocumentPreviewEventDetail,
	type DocumentPreviewPanelContent,
} from "./documentPanelEvents";

type Options = {
	/** Called as a document is opened, before it is shown. */
	onOpen?: () => void;
};

/**
 * Listens for `chatevent` with {@link DOCUMENT_PREVIEW_EVENT} and holds the
 * page of the document the pane should show, if any.
 */
export function useDocumentPreviewPanel(options: Options = {}) {
	const [preview, setPreview] = createSignal<DocumentPreviewPanelContent>();

	onMount(() => {
		const onChatEvent = (evt: Event) => {
			const e = evt as CustomEvent<DocumentPreviewEventDetail>;
			if (e.detail?.type !== DOCUMENT_PREVIEW_EVENT || !e.detail.content) {
				return;
			}
			const { is_open, ...content } = e.detail.content;
			if (is_open) {
				options.onOpen?.();
				setPreview(content);
			} else if (preview()?.url === content.url) {
				// A thumbnail strip stepping along the document the pane holds:
				// the pane turns to the page, without being opened by it.
				setPreview(content);
			}
		};
		document.addEventListener("chatevent", onChatEvent);
		onCleanup(() => document.removeEventListener("chatevent", onChatEvent));
	});

	return {
		preview,
		close: () => setPreview(undefined),
	};
}
